"use strict";
exports.__esModule = true;
exports.getMinRelayFee = void 0;
// correspond ~ to min relay fees but determined empirically for a tx to be accepted by network
var minFees = {
    bitcoin: 1000,
    bitcoin_gold: 1000,
    pivx: 2000,
    stakenet: 1000,
    stealthcoin: 2000,
    qtum: 4000,
    stratis: 2000,
    vertcoin: 2000,
    viacoin: 2000,
    peercoin: 2000
};
var getMinRelayFee = function (currency) {
    return minFees[currency.id] || 0;
};
exports.getMinRelayFee = getMinRelayFee;
//# sourceMappingURL=fees.js.map